import API from '../instances/sportradar_instance';
import { PARTNER_IDENTIFIER } from '../partners'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  /**
   * Get the application config
   * @return {AxiosPromise<any>}
   */
  getBigScreenConfig() {
    return API().get('bigscreen-config');
  },
  /**
   * Get the available epg channels
   * @return {AxiosPromise<any>}
   */
  getChannels() {
    return API().get('epg/channels');
  },
  getPage(pageId) {
    return API().get(`page/${pageId}/content`);
  },
  /**
   * Get the content for a channel on a specific day
   * @param channelId
   * @param date YYYY-MM-DD
   * @return {AxiosPromise<any>}
   */
  getChannelEPG(channelId, date) {
    return API().get(`epg/channel/${channelId}?content=true&day=${date}`);
  },
  getAsset(assetId) {
    return API()
      .get(`content/${assetId}`)
      .then(response => {
        const asset = response.data.data;
        return {...asset, partner: PARTNER_IDENTIFIER.RLAXX}
      })
  },
  getStreamURL(assetId) {
    return API().post(`content/${assetId}/access/hls`);
  },
  getPlayerSettings(assetId) {
    return API().get(`content/${assetId}/player-setting`);
  },
  getRelatedElements(assetId, limit = 20) {
    return API().get(`content/${assetId}/related-content?limit=${limit}`);
  },
};
